'use strict';

(function () {
    'use strict';

    angular.module('home', ['ui.router', 'common']);
})();